import React, { useState, useEffect } from 'react';
import { Col, Form, Row, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  getPostalCodes,
  getCities,
  getSubCities,
  getStates,
} from '../services/api';

export type Props = {
  province?: string;
  disabledProvince?: boolean;
};

const AddressSelection: React.FC<Props> = ({
  province,
  disabledProvince = false,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [postalCodes, setPostalCodes] = useState<any>([]);
  const [subCities, setSubCities] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [selectProvince, setSelectProvince] = useState(province);

  useEffect(() => {
    setSelectProvince(province);
  }, [province]);

  useEffect(() => {
    loadCities(selectProvince);
  }, [selectProvince]);

  const loadSubCities = async (value: any) => {
    setSubCities(await getSubCities('', value));
  };

  const loadCities = async (value: any) => {
    setCities(await getCities('', value));
  };

  const loadStates = async (value: any) => {
    setStates(await getStates(value));
  };

  const loadPostCode = async (value: any) => {
    setPostalCodes(await getPostalCodes(value));
  };

  const onSubCityChange = async (value: any = null) => {
    return;
  };

  const onCityChange = async (value: any = null) => {
    await loadSubCities(value);
    await loadPostCode(value);
    return;
  };

  const onStateChange = async (value: any = null) => {
    await loadCities(value);
    form.setFieldsValue({
      province: null,
      district: null,
      subDistrict: null,
    });
    return;
  };

  const initialPostalCode = async () => {
    setPostalCodes(await getPostalCodes());
  };

  useEffect(() => {
    loadStates('');
  }, []);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          {' '}
          <Form.Item name={'province'} label="จังหวัด">
            <Select
              disabled={disabledProvince}
              showSearch
              filterOption={(input, option: any) =>
                option.label.indexOf(input.toLowerCase()) >= 0
              }
              options={states}
              placeholder="จังหวัด"
              onChange={onStateChange}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={'district'}
            label="เขต / อำเภอ"
            rules={[
              {
                required: true,
                message: 'กรุณากรอกข้อมูล',
              },
            ]}
          >
            <Select
              showSearch
              filterOption={(input, option: any) =>
                option.label.indexOf(input.toLowerCase()) >= 0
              }
              onChange={onCityChange}
              options={cities}
              placeholder="เขต / อำเภอ"
            ></Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Form.Item
            name={'subDistrict'}
            label="แขวง / ตำบล"
            rules={[
              {
                required: true,
                message: 'กรุณากรอกข้อมูล',
              },
            ]}
          >
            <Select
              showSearch
              filterOption={(input, option: any) =>
                option.label.indexOf(input.toLowerCase()) >= 0
              }
              onChange={onSubCityChange}
              options={subCities}
              placeholder="แขวง / ตำบล"
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={'postCode'}
            label="รหัสไปรษณีย์"
            rules={[
              {
                required: true,
                message: 'กรุณากรอกข้อมูล',
              },
            ]}
          >
            <Select
              showSearch
              options={postalCodes}
              placeholder="รหัสไปรษณีย์"
            ></Select>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default AddressSelection;
